import { ASSETS, BRAND } from "@/lib/brand";

export default function CTASection() {
  return (
    <section data-testid="home-cta" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={ASSETS.lifestyle.handshake}
          alt=""
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/75" />
      </div>
      <div className="container-page relative section-pad text-cream">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <div className="eyebrow text-taupe mb-5 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-taupe" /> A Homely Abode
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.05]">
              Your <span className="italic text-taupe">Homely Abode</span> Journey Starts Here.
            </h2>
            <p className="mt-6 max-w-2xl text-base md:text-lg font-light text-cream/80">
              Are you ready to build a resilient property portfolio backed by expert consulting and
              tailor-made marketing strategies?
            </p>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-3 lg:items-end">
            <a
              href={BRAND.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-section-primary"
              className="btn-primary"
            >
              Start Your Property Journey
            </a>
            <a
              href={BRAND.valuationLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-section-valuation"
              className="text-[0.72rem] tracking-[0.22em] uppercase text-taupe hover:text-cream"
            >
              or Get Property Valuation →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
